<h2 mat-dialog-title>{{ pageInfo?.name }}</h2>
<mat-dialog-content>
  <p style="margin: 0; font-size: 14px; line-height: 1.5; color: #3d4a44;">{{ pageInfo?.description }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button style="color: #007041;" (click)="onNoClick()">Close</button>
</mat-dialog-actions>
